import { USER_ROLE, USER_TYPE } from '../constants/statuses';

export function getUserRoleAccess(roles = []) {
  return {
    admin: roles.includes(USER_ROLE.SUPER_ADMIN),
  };
}

export function getUserTypeAccess(type = '') {
  return {
    manager: type === USER_TYPE.MANAGER,
    developer: type === USER_TYPE.DEVELOPER,
    worker: type === USER_TYPE.BUYER,
  };
}
